import { useState } from 'react'
import { FileDownload } from '@/assets/icons'
import { CircularProgressContinuousSized } from '@/components/loaders/CircularProgressContinuous'
import { AnalyticsEvent } from '@/analytics/schema/events.schema'
import { trackMedChronEvent } from '@/analytics/utils/medchron-analytics'
import { downloadMedChronAssetExcel } from '../fetch/download-med-chron-asset-excel'

interface MedChronAssetDownloadButtonProps {
  assetId: string
}

/**
 * Downloads the living chronology as an Excel file.
 */
export default function MedChronAssetDownloadButton(props: MedChronAssetDownloadButtonProps) {
  const { assetId } = props
  const [isLoading, setIsLoading] = useState(false)

  const handleDownload = async () => {
    if (isLoading) return
    setIsLoading(true)
    trackMedChronEvent(AnalyticsEvent.MedChronAssetDownloadClicked, { medChronAssetId: assetId })
    try {
      await downloadMedChronAssetExcel(assetId, 'Medical Chronology.xlsx')
    } catch (error) {
      console.error('Error downloading medical chronology Excel:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="inline-flex items-center justify-center w-7 h-7">
      {isLoading ? (
        <CircularProgressContinuousSized size={14} thickness={4} />
      ) : (
        <button
          onClick={handleDownload}
          className="w-7 h-7 flex items-center justify-center rounded-md ring-1 ring-brand-500 transition-colors hover:bg-brand-neutral-200"
          aria-label="Download the Medical Chronology"
        >
          <FileDownload className="w-4 h-4 text-brand-500" />
        </button>
      )}
    </div>
  )
}
